import { spacing } from './spacing';

export const layout = {
  breakpoints: {
    desktop: 'md',
  },
  topBar: {
    height: `calc(4rem + ${spacing['safe-top']})`,
  },
};
